import cx from 'classnames'
import { Marketing, Label } from 'designsystem/Text'

interface SectionHeaderProps extends React.HTMLAttributes<HTMLElement> {
  label?: string
  title: string
  subline?: string | JSX.Element
  theme?: 'light' | 'dark'
  highlight?: 'blue' | 'magenta' | 'red' | 'purple'
  paddingToContent?: 'default' | 'small' | 'none'
  className?: string
}

export const SectionHeader = ({
  label,
  title,
  subline,
  theme = 'light',
  highlight,
  paddingToContent = 'default',
  className,
}: SectionHeaderProps): JSX.Element => {
  return (
    <header
      className={cx(
        'max-w-896 mx-auto',
        paddingToContent === 'default' && 'pb-16 md:pb-20 lg:pb-30',
        paddingToContent === 'small' && 'pb-10 md:pb-16 lg:pb-20',
        paddingToContent === 'none' && '',
        className,
      )}
    >
      {label && (
        <Label
          className={cx(
            'mb-4 sm:text-center',
            !highlight && theme === 'light' && 'text-neutral-60',
            !highlight && theme === 'dark' && 'text-neutral-on-dark-60',

            highlight === 'blue' && 'text-blue',
            highlight === 'magenta' && 'text-magenta',
            highlight === 'red' && 'text-red',
            highlight === 'purple' && 'text-purple',
          )}
        >
          {label}
        </Label>
      )}
      <Marketing.H2 className={cx(theme === 'dark' && 'text-white')}>
        {title}
      </Marketing.H2>
      {subline && (
        <Marketing.SubHeadline
          className={cx(
            'spacer-3xs max-w-768 mx-auto',
            theme === 'dark' && '!text-neutral-on-dark-60',
          )}
        >
          {subline}
        </Marketing.SubHeadline>
      )}
    </header>
  )
}
